/*
 * SMParts — Bike-Filter fuer Kollektionen und die Seite "Passend fuer
 * dein Bike".
 *
 * Gefiltert wird nicht hier, sondern von Shopify: der Tag des Modells
 * steht im Pfad (/collections/ktm/fit-ktm-125-exc). So bleiben
 * Sortierung, Seitenaufteilung und die echten Produktkarten, wie sie
 * sind. Dieses Skript setzt nur die Links, haelt die Leiste aktuell und
 * prueft das Baujahr nach, das im Pfad nicht steckt.
 */
(function () {
  'use strict';

  /* Gleiche Schreibweise wie smp-fitment.js und die Tags. */
  function slug(s) {
    return (s || '')
      .toString()
      .toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  /*
   * Direkt aus dem Speicher lesen statt ueber window.SMPBike: beide
   * Skripte laden mit defer, und wer zuerst laeuft, ist nicht sicher.
   * Ohne Bike wuerde eine gefilterte Seite sonst auf "alle" springen.
   */
  var SPEICHER = 'smp:bike';
  function bike() {
    try {
      var b = JSON.parse(window.localStorage.getItem(SPEICHER) || 'null');
      return b && b.marke ? b : null;
    } catch (e) {
      return null;
    }
  }

  function name(b) {
    return [b.marke, b.modell, b.baujahr].filter(Boolean).join(' · ');
  }

  /* Tag, wie Shopify ihn im Pfad erwartet: fit:ktm:125-exc -> fit-ktm-125-exc */
  function tagFuer(b) {
    return 'fit-' + slug(b.marke) + '-' + slug(b.modell);
  }

  /* Tag im aktuellen Pfad, oder '' wenn ungefiltert. */
  function aktiverTag(basis) {
    var pfad = window.location.pathname;
    if (pfad.indexOf(basis + '/') !== 0) return '';
    var t = decodeURIComponent(pfad.slice(basis.length + 1).split('/')[0] || '');
    return t.toLowerCase().replace(/:/g, '-');
  }

  /* Suchteil der URL behalten (Sortierung, view), aber ohne Seitenzahl. */
  function suche() {
    var p = new URLSearchParams(window.location.search);
    p.delete('page');
    var s = p.toString();
    return s ? '?' + s : '';
  }

  /*
   * Baujahr nachpruefen.
   *
   * Im Pfad steht nur das Modell. Ein Teil, das z. B. erst ab 2016
   * passt, traegt zusaetzlich "fit:ktm:300-exc:2016-2027". Hat ein
   * Produkt fuer dieses Modell eine Spanne, gilt nur die — passt das
   * Baujahr nicht hinein, wird die Karte ausgeblendet.
   */
  function jahrPasst(eintraege, b) {
    var schluessel = slug(b.marke) + ':' + slug(b.modell) + ':';
    var spannen = eintraege.filter(function (e) { return e.indexOf(schluessel) === 0; });
    if (!spannen.length) return true;
    var jahr = parseInt(b.baujahr, 10);
    if (isNaN(jahr)) return true;
    return spannen.some(function (e) {
      var s = e.slice(schluessel.length).split('-');
      var von = parseInt(s[0], 10);
      var bis = parseInt(s[1] !== undefined ? s[1] : s[0], 10);
      return jahr >= von && jahr <= bis;
    });
  }

  function kartenPruefen(b) {
    document.querySelectorAll('#product-grid > li[data-smp-jahre]').forEach(function (li) {
      var e = (li.getAttribute('data-smp-jahre') || '').split(',').filter(Boolean);
      li.hidden = !jahrPasst(e, b);
    });
  }

  /*
   * Die Seitenzahlen-Links von Shopify lassen ?view=passend weg — Seite 2
   * waere dann die normale Kollektion. Hier wieder anhaengen.
   */
  function seitenLinksBehalten() {
    var view = new URLSearchParams(window.location.search).get('view');
    if (!view) return;
    document.querySelectorAll('.pagination a[href]').forEach(function (a) {
      var u = new URL(a.getAttribute('href'), window.location.origin);
      if (u.searchParams.get('view') === view) return;
      u.searchParams.set('view', view);
      a.setAttribute('href', u.pathname + u.search);
    });
  }

  /*
   * Zubehoer und offene Passformen unter die passenden Teile
   * (Regel Andreas, Runde 6).
   *
   * Im Pfad steht nur EIN Tag, Shopify liefert also nur die Teile mit
   * passendem Modell-Tag. Gewuenscht ist aber: nach der Bike-Wahl bleibt
   * alles sichtbar, was nicht nachweislich NICHT passt. Deshalb holen wir
   * die ganze Kollektion als Karten (?view=bfkarten) und sortieren:
   *   - passender Modell-Tag      -> steht schon im Raster oben
   *   - bikefilter:zubehoer/fit:all -> Block "Zubehoer & universell"
   *   - bikefilter:geprueft ohne Treffer -> passt nachweislich nicht, weg
   *   - alles andere              -> Block "Passform auf Anfrage"
   * Nur auf der letzten Rasterseite, sonst stuenden die Bloecke unter
   * jeder Seite.
   */
  var SICHTBAR_ANFANG = 12;

  function kartenHolen(basis) {
    function seite(n) {
      return fetch(basis + '?view=bfkarten&page=' + n)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var ul = doc.querySelector('[data-smp-bf-karten]');
          return { karten: ul ? Array.prototype.slice.call(ul.children) : [], seiten: ul ? parseInt(ul.getAttribute('data-seiten') || '1', 10) : 1 };
        });
    }
    return seite(1).then(function (erste) {
      var rest = [];
      for (var n = 2; n <= erste.seiten; n++) rest.push(seite(n));
      return Promise.all(rest).then(function (weitere) {
        return weitere.reduce(function (alle, s) { return alle.concat(s.karten); }, erste.karten);
      });
    });
  }

  function block(titel, text, karten, modifier) {
    var box = document.createElement('div');
    box.className = 'smp-bf-uni smp-bf-uni--' + modifier;
    box.setAttribute('data-smp-bf-gruppe', modifier);
    box.innerHTML =
      '<div class="page-width"><h2 class="smp-bf-uni__titel"></h2><p class="smp-bf-uni__text"></p></div>' +
      '<div class="collection page-width"><ul class="grid product-grid grid--2-col-tablet-down grid--4-col-desktop"></ul></div>';
    box.querySelector('h2').textContent = titel + ' (' + karten.length + ')';
    box.querySelector('p').textContent = text;
    var ul = box.querySelector('ul');
    karten.forEach(function (li, i) {
      var k = document.importNode(li, true);
      if (i >= SICHTBAR_ANFANG) k.hidden = true;
      ul.appendChild(k);
    });
    if (karten.length > SICHTBAR_ANFANG) {
      var mehr = document.createElement('button');
      mehr.type = 'button';
      mehr.className = 'smp-bf-uni__mehr button button--secondary';
      mehr.textContent = 'Alle ' + karten.length + ' zeigen';
      mehr.addEventListener('click', function () {
        ul.querySelectorAll('li[hidden]').forEach(function (k) { k.hidden = false; });
        mehr.remove();
      });
      box.querySelector('.collection').appendChild(mehr);
    }
    return box;
  }

  function gruppenZeigen(basis, b, fertig) {
    var raster = document.getElementById('ProductGridContainer');
    if (!raster || document.querySelector('[data-smp-bf-gruppe]')) return;
    /* Dawn setzt den Pfeil "weiter" als letzten Listenpunkt, solange es
       eine naechste Seite gibt. Gezaehlt wird immer (fuer die Leiste),
       gezeigt erst unter der letzten Seite der passenden Teile. */
    var letzteSeite = !document.querySelector('.pagination__list > li:last-child > a.pagination__item-arrow');

    var modell = 'fit:' + slug(b.marke) + ':' + slug(b.modell);
    kartenHolen(basis).then(function (karten) {
      var zubehoer = [];
      var anfrage = [];
      karten.forEach(function (li) {
        var tags = (li.getAttribute('data-smp-tags') || '').split(',').filter(Boolean);
        if (tags.indexOf(modell) !== -1) return;
        if (tags.indexOf('bikefilter:zubehoer') !== -1 || tags.indexOf('fit:all') !== -1) {
          zubehoer.push(li);
        } else if (tags.indexOf('bikefilter:geprueft') !== -1) {
          return;
        } else {
          anfrage.push(li);
        }
      });
      if (fertig) fertig(zubehoer.length, anfrage.length);
      if (!letzteSeite) return;
      var nach = raster;
      if (zubehoer.length) {
        var z = block('Zubehör & universell', 'Passt unabhängig vom Modell – die passende Ausführung, Größe oder das passende Bauteil wählst du am Produkt.', zubehoer, 'zubehoer');
        nach.parentNode.insertBefore(z, nach.nextSibling);
        nach = z;
      }
      if (anfrage.length) {
        var a = block('Passform auf Anfrage', 'Für dein Bike haben wir dazu noch keine bestätigte Angabe – schreib uns, wir prüfen es für dich.', anfrage, 'anfrage');
        nach.parentNode.insertBefore(a, nach.nextSibling);
      }
    }).catch(function () {});
  }

  function setup(root) {
    if (root.smpBereit) return;
    root.smpBereit = true;

    var modus = root.getAttribute('data-modus') || 'leiste';
    var basis = root.getAttribute('data-basis') || '/collections/all';
    var anzahl = parseInt(root.getAttribute('data-anzahl') || '0', 10);

    var el = {
      label: root.querySelector('[data-smp-bf-label]'),
      bike: root.querySelector('[data-smp-bf-bike]'),
      haupt: root.querySelector('[data-smp-bf-haupt]'),
      aendern: root.querySelector('[data-smp-bf-aendern]')
    };

    function hauptAlsWaehler(text) {
      el.haupt.textContent = text;
      el.haupt.href = '#';
      el.haupt.setAttribute('data-smp-bike-oeffner', '');
    }

    function hauptAlsLink(text, href) {
      el.haupt.textContent = text;
      el.haupt.href = href;
      el.haupt.removeAttribute('data-smp-bike-oeffner');
    }

    function zeichnen() {
      var b = bike();
      var aktiv = aktiverTag(basis);
      var gefiltert = aktiv.indexOf('fit-') === 0;

      document.documentElement.classList.toggle('smp-passend-ohne-bike', modus === 'seite' && !b);

      if (b && (modus === 'seite' || gefiltert) && aktiv !== tagFuer(b)) {
        /* Bike gewaehlt oder gewechselt: zur passenden Liste. Mit
           replace, damit "Zurueck" nicht in einer Schleife landet. */
        window.location.replace(basis + '/' + tagFuer(b) + suche());
        return;
      }

      if (!b && gefiltert && modus === 'leiste') {
        window.location.replace(basis + suche());
        return;
      }

      root.hidden = false;
      el.aendern.hidden = !b;

      if (!b) {
        el.label.textContent = modus === 'seite'
          ? 'Wähle dein Bike – wir zeigen dir, was passt.'
          : 'Nur Teile für dein Bike zeigen?';
        el.bike.textContent = '';
        hauptAlsWaehler('Bike wählen');
        return;
      }

      if (!gefiltert) {
        el.label.textContent = 'Dein Bike:';
        el.bike.textContent = name(b);
        hauptAlsLink('Nur passende Teile', basis + '/' + tagFuer(b) + suche());
        return;
      }

      kartenPruefen(b);
      var sichtbar = anzahl;
      var versteckt = document.querySelectorAll('#product-grid > li[hidden]').length;
      if (versteckt) sichtbar = Math.max(0, anzahl - versteckt);

      if (anzahl === 0) {
        el.label.textContent = 'Für dein Bike haben wir hier noch keine Angaben:';
        el.bike.textContent = name(b);
      } else {
        el.label.textContent = 'Passend für';
        el.bike.textContent = name(b) + ' · ' + sichtbar + (sichtbar === 1 ? ' Teil' : ' Teile');
      }

      if (modus === 'seite') {
        el.haupt.hidden = true;
        seitenLinksBehalten();
      } else {
        hauptAlsLink('Alle Teile zeigen', basis + suche());
      }
      var text = el.bike.textContent;
      gruppenZeigen(basis, b, function (z, a) {
        var teile = [];
        if (z) teile.push(z + ' Zubehör');
        if (a) teile.push(a + ' auf Anfrage');
        if (teile.length) el.bike.textContent = text + ' + ' + teile.join(' + ');
      });
    }

    el.haupt.addEventListener('click', function (e) {
      if (el.haupt.hasAttribute('data-smp-bike-oeffner')) e.preventDefault();
    });

    document.addEventListener('smp:bike-changed', zeichnen);
    window.addEventListener('storage', function (e) {
      if (e.key === SPEICHER) zeichnen();
    });
    zeichnen();

    /* Sortieren laedt das Raster per Skript neu — danach die Baujahre
       noch einmal pruefen. */
    var raster = document.getElementById('ProductGridContainer');
    if (raster && 'MutationObserver' in window) {
      new MutationObserver(function () {
        var b = bike();
        if (b && aktiverTag(basis).indexOf('fit-') === 0) kartenPruefen(b);
        if (modus === 'seite') seitenLinksBehalten();
      }).observe(raster, { childList: true, subtree: true });
    }
  }

  function init() {
    document.querySelectorAll('[data-smp-bikefilter]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
